export default __webpack_public_path__ + "static/media/car-image-not-available.5188514e.jpg";